import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT_SECTIONS, ROUTES } from '@/app/routes';
import { useTranslations } from '@/hooks';
import { useCreateSiteMutation } from '../../api/sitesApi';
import { SiteForm } from './SiteForm';
import { EMPTY_SITE_FORM } from '../../constants/sites.constants';

export const AddSitePage = () => {
  const t = useTranslations();
  const navigate = useNavigate();

  const [createSite, { isLoading: isSubmitting }] = useCreateSiteMutation();

  const goToSites = useCallback(() => {
    navigate(ROUTES.accountSetup(ACCOUNT_SECTIONS.companyStructure));
  }, [navigate]);

  const handleSubmit = useCallback(
    async (values) => {
      const result = await createSite(values);
      if (result.error) return;
      goToSites();
    },
    [createSite, goToSites],
  );

  return (
    <SiteForm
      title={t('SITES_ADD_TITLE')}
      initialValues={EMPTY_SITE_FORM}
      onSubmit={handleSubmit}
      onClose={goToSites}
      isSubmitting={isSubmitting}
    />
  );
};
